import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import determineAnimation from '_helpers/generic/Animations';
import useAnimation from '_helpers/hooks/useAnimation';
import Tooltip from 'components/atoms/tooltip';
import ANIMATION_DURATION from 'constants/common/animation-duration';
import arrowIcon from 'assets/icons/sidebar/arrow.svg';
import MENU_ITEMS from './constants/ConstMenuItems';
import './menu.scss';

export default function Menu() {
  const { setAnimation, currentPageIndex, setCurrentPageIndex } = useAnimation();

  const [isOpen, setIsOpen] = useState(false);
  const [toggleAnimation, setToggleAnimation] = useState(false);

  const openSidebar = async () => {
    setIsOpen(true);
    await new Promise(r => {
      setTimeout(r, 50);
    });
    setToggleAnimation(true);
  };

  const closeSidebar = async () => {
    setToggleAnimation(false);
    await new Promise(r => {
      setTimeout(r, (ANIMATION_DURATION - 0.45) * 1000);
    });
    setIsOpen(false);
  };

  return (
    <div id="menu" className="relative">
      <button
        type="button"
        className="absolute right-3 top-3"
        onClick={() => (isOpen ? closeSidebar() : openSidebar())}>
        <Tooltip message="Toggle sidebar" styles="!-bottom-14">
          <img
            src={arrowIcon}
            alt="Toggle sidebar"
            className={`h-6 w-6 opacity-30 hover:opacity-100 ${!toggleAnimation && 'rotate-180'}`}
            style={{ transitionDuration: `${ANIMATION_DURATION}s` }}
          />
        </Tooltip>
      </button>
      <div
        id="menu-items"
        className={`px-7 hidden lg:flex h-full flex-col justify-between text-3xl py-14 rocket bg-[rgba(255,255,255,0.1)] rounded-tr-3xl items-center ${
          toggleAnimation ? 'w-80' : 'w-32'
        } `}
        style={{ transitionDuration: `${ANIMATION_DURATION}s` }}>
        {MENU_ITEMS.map((e, i) => (
          <Tooltip key={e.link} message={isOpen ? undefined : e?.title} styles="w-full">
            <Link
              onClick={() => {
                setAnimation(determineAnimation(e?.link));
                setCurrentPageIndex(i);
              }}
              to={e.link}
              className={`w-full px-3 gap-7 hover:opacity-100 menu-item flex items-center justify-start ${
                i === currentPageIndex ? 'opacity-100' : 'opacity-30'
              } rocket w-full`}
              style={{ justifyContent: toggleAnimation ? 'center' : 'start' }}>
              <img src={e?.icon} className="h-10 w-10" alt="Menu item icon" />
              {isOpen && (
                <div
                  className="whitespace-nowrap text-[1.5rem]"
                  style={{
                    scale: toggleAnimation ? '100%' : 0,
                    transitionDuration: `${ANIMATION_DURATION}s`,
                  }}>
                  {e.title}
                </div>
              )}
            </Link>
          </Tooltip>
        ))}
      </div>
    </div>
  );
}
